import { Location, History } from 'history';

import { createRequiredContext } from 'ha/core/RequiredContext';

export interface Params {
  [key: string]: string;
}

interface LocationParamsContextValue {
  params: Params;
  location: Location;
}

const LocationParamsContext = createRequiredContext<LocationParamsContextValue>(
  'LocationParamsContext',
);
export const LocationParamsProvider = LocationParamsContext.Provider;
export const LocationParamsConsumer = LocationParamsContext.Consumer;

const HistoryContext = createRequiredContext<History>('HistoryContext');
export const HistoryProvider = HistoryContext.Provider;
export const HistoryConsumer = HistoryContext.Consumer;

// named useHistory to be aligned with react-router v5 hooks to ease the potential upgrade
// router object is a wrapper around history with most functions being the same
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/hooks.md#usehistory
export const useHistory = HistoryContext.useContext;

export const useLocation = () => {
  const { location } = LocationParamsContext.useContext();

  return location;
};

export const useParams = () => {
  const { params } = LocationParamsContext.useContext();

  return params;
};
